<!-- ── Search (server-side: consultant, opportunity, end client) ──── -->
<div class="board-toolbar">
  <div class="search-input">
    <nb-icon class="search-icon" icon="search-outline"></nb-icon>
    <input nbInput
           type="text"
           placeholder="{{ 'search.placeholder' | translate }}"
           [(ngModel)]="searchQuery"
           (ngModelChange)="onSearchChange($event)"
           fieldSize="small">
    @if (searchQuery) {
      <nb-icon class="clear-icon" icon="close-circle" (click)="clearSearch()"></nb-icon>
    }
  </div>
</div>

<div *ngIf="errorMessage" class="error-banner">{{ errorMessage }}</div>

<!-- Board-wide empty state: nothing in any column yet. -->
<div class="empty-state" *ngIf="!errorMessage && !isLoading && isBoardEmpty">
  <nb-icon class="empty-icon" icon="layout-outline"></nb-icon>
  <p class="empty-title">{{ 'crm.no_submissions' | translate }}</p>
  <p class="empty-subtext">{{ 'crm.board.empty_subtext' | translate }}</p>
</div>

<div class="board" #boardEl *ngIf="!errorMessage && !(!isLoading && isBoardEmpty)">
  <div class="board-column"
       *ngFor="let column of columns"
       [class]="'stage-' + stageAccent(column.status)"
       [class.is-withdrawn]="column.isWithdrawn">
    <div class="column-header">
      <span class="column-label">{{ ('crm.sub.' + column.status) | translate }}</span>
      <span class="column-count" [class.has-cards]="column.cards.length > 0">{{ column.cards.length }}</span>
    </div>

    <div
      class="column-body"
      cdkDropList
      [id]="dropListId(column.status)"
      [cdkDropListData]="column.cards"
      [cdkDropListConnectedTo]="columnIds"
      [cdkDropListSortingDisabled]="true"
      (cdkDropListDropped)="onDrop($event, column.status)">

      <div class="sub-card" *ngFor="let card of column.cards"
           [class.is-frozen]="isFrozen(card)"
           cdkDrag [cdkDragDisabled]="isFrozen(card)">
        <!-- Name opens the submission detail; stop mousedown so cdkDrag doesn't
             hijack the click (rest of the card stays draggable). -->
        <span class="sub-consultant" role="link" tabindex="0"
              (click)="openSubmission(card)"
              (keyup.enter)="openSubmission(card)"
              (mousedown)="$event.stopPropagation()">{{ consultantName(card) }}</span>
        <span class="sub-opp">{{ card.opportunityTitle }}</span>
        <span class="sub-endclient" *ngIf="card.endClientName">{{ card.endClientName }}</span>

        <!-- Drag-free, keyboard-operable stage change (WCAG gesture alternative).
             Stop drag from hijacking pointer/keyboard interaction on the select. -->
        <div class="sub-card-footer"
             (mousedown)="$event.stopPropagation()" (touchstart)="$event.stopPropagation()">
          @if(isFrozen(card) && card.converted_Project_id; as pId){
            <a [routerLink]="['/projects', pId]" class="project-link" (mousedown)="$event.stopPropagation()">
              <nb-icon icon="external-link-outline"></nb-icon>
              {{ 'crm.view_project' | translate }}
            </a>
          } @else {
            <nb-select size="tiny" class="stage-select" [placeholder]="'crm.move_to' | translate"
                       [ngModel]="card.status"
                       (selectedChange)="onStageChange(card, $event)"
                       [attr.aria-label]="'crm.move_aria' | translate:{name: consultantName(card)}">
              <nb-option *ngFor="let st of pipeline" [value]="st">{{ ('crm.sub.' + st) | translate }}</nb-option>
              <nb-option value="withdrawn">{{ 'crm.sub.withdrawn' | translate }}</nb-option>
            </nb-select>
          }
          <!-- CV-ready indicator: positive signal only. -->
          @if (hasCvReady(card)) {
            <span class="cv-dot cv-ready"
                  [title]="'crm.cv_ready_tooltip' | translate"
                  [attr.aria-label]="'crm.cv_ready_tooltip' | translate">
            </span>
          }
          <!-- Remove action: only for non-won, non-converted submissions.
               Revealed on card hover/focus; the detail header keeps an
               always-visible Remove. -->
          @if (canRemove(card)){
            <button nbButton ghost size="tiny" status="danger" class="card-remove"
                  (mousedown)="$event.stopPropagation()"
                  (click)="removeSubmission(card)">{{ 'crm.remove' | translate }}</button>
          }
        </div>
      </div>

      <!-- Per-column placeholder is fine while other columns hold cards. -->
      <p class="column-empty" *ngIf="!column.cards.length">&mdash;</p>
    </div>
  </div>
</div>
